import { CaseData } from '../PageContent'

import { CaseImage } from '../CaseImage'
import { CaseVideo } from '../CaseVideo'

interface LayoutProps {
 data: CaseData
 files: {
  type: string
  src: string
 }[]
}

export function Layout9({ data, files }: LayoutProps) {
 return (
  <div className="container">
   <div className="flex flex-wrap">
    <div className="w-full pt-2.5" data-aos="fade-left">
     <CaseVideo
      videoIndex={0}
      add="main-embed-container"
      video={files[1].src}
     />
    </div>
   </div>
   <div className="flex flex-wrap">
    <div className="w-full pt-2.5" data-aos="fade-right">
     <CaseImage
      imageIndex={0}
      folder={data.cf_client_name}
      image={files[0].src}
     />
    </div>
   </div>
   <div className="flex flex-wrap">
    <div className="w-full pt-2.5" data-aos="fade-left">
     <CaseImage
      imageIndex={0}
      folder={data.cf_client_name}
      image={files[2].src}
     />
    </div>
   </div>

   <div className="flex flex-wrap">
    <div
     className="w-full pt-2.5 sm:w-full md:w-1/2 lg:w-1/2 pr-1.5"
     data-aos="fade-left"
    >
     <CaseImage
      imageIndex={0}
      folder={data.cf_client_name}
      image={files[4].src}
      add="fullHeight"
     />
    </div>
    <div
     className="w-full pt-2.5 sm:w-full md:w-1/2 lg:w-1/2 pl-1.5"
     data-aos="fade-right"
    >
     <CaseImage
      imageIndex={0}
      folder={data.cf_client_name}
      image={files[6].src}
      add="fullHeight"
     />
    </div>
   </div>

   <div className="flex flex-wrap">
    <div
     className="w-full pt-2.5 sm:w-full md:w-1/2 lg:w-1/2 pr-1.5 max-[768px]:pr-0"
     data-aos="fade-right"
    >
     <CaseVideo
      videoIndex={0}
      add="embed-responsive clube"
      video={files[3].src}
     />
    </div>
    <div
     className="w-full pt-2.5 sm:w-full md:w-1/2 lg:w-1/2 pl-1.5 max-[768px]:pl-0"
     data-aos="fade-left"
    >
     <CaseVideo
      videoIndex={0}
      add="embed-responsive clube"
      video={files[5].src}
     />
    </div>
   </div>

   <div className="flex flex-wrap">
    <div className="w-full pt-2.5" data-aos="fade-right">
     <CaseImage
      imageIndex={0}
      folder={data.cf_client_name}
      image={files[7].src}
     />
    </div>
   </div>

   <div className="flex flex-wrap">
    <div
     className="w-1/2 pt-2.5 sm:w-1/2 md:w-1/4 lg:w-1/4 pr-1.5"
     data-aos="fade-left"
    >
     <CaseImage
      imageIndex={0}
      folder={data.cf_client_name}
      image={files[8].src}
     />
    </div>
    <div
     className="w-1/2 pt-2.5 sm:w-1/2 md:w-1/4 lg:w-1/4 px-1.5 max-[768px]:pr-0"
     data-aos="fade-right"
    >
     <CaseImage
      imageIndex={0}
      folder={data.cf_client_name}
      image={files[11].src}
     />
    </div>
    <div
     className="w-1/2 pt-2.5 sm:w-1/2 md:w-1/4 lg:w-1/4 px-1.5 max-[768px]:pl-0"
     data-aos="fade-left"
    >
     <CaseImage
      imageIndex={0}
      folder={data.cf_client_name}
      image={files[9].src}
     />
    </div>
    <div
     className="w-1/2 pt-2.5 sm:w-1/2 md:w-1/4 lg:w-1/4 pl-1.5"
     data-aos="fade-right"
    >
     <CaseImage
      imageIndex={0}
      folder={data.cf_client_name}
      image={files[10].src}
     />
    </div>
   </div>
  </div>
 )
}
